import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { 
  persistStore, 
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './slices/authSlice';
import agentsReducer from './slices/agentsSlice';
import uiReducer from './slices/uiSlice';
import whatsappReducer from './slices/whatsappSlice';
import monitoringReducer from './slices/monitoringSlice';
import tenantReducer from './slices/tenantSlice';
import { apiSlice } from './slices/apiSlice';

// Configuration Redux Persist
const persistConfig = {
  key: 'digitalcloud360-root',
  version: 1,
  storage,
  whitelist: ['auth'], // Seules les données d'auth seront persistées
  blacklist: ['api'], // Exclure RTK Query du persist
};

// Root Reducer
const rootReducer = combineReducers({
  auth: authReducer,
  agents: agentsReducer,
  ui: uiReducer,
  whatsapp: whatsappReducer,
  monitoring: monitoringReducer,
  tenant: tenantReducer,
  api: apiSlice.reducer,
});

// Persisted Reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configuration du Store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        ignoredPaths: ['api.queries', 'api.mutations'],
      },
    }).concat(apiSlice.middleware), // Ajouter RTK Query middleware
  devTools: process.env.NODE_ENV !== 'production',
});

// Persistor
export const persistor = persistStore(store);

// Types pour TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export des actions (avec namespace pour éviter les conflits)
export * from './slices/authSlice';
export * from './slices/agentsSlice';
export * from './slices/uiSlice';
export * from './slices/whatsappSlice';
export * as monitoringActions from './slices/monitoringSlice';
export * from './slices/tenantSlice';
export { apiSlice } from './slices/apiSlice';
export * from './slices/apiSlice';
